<template>
  <teleport to="body">
    <div class="modal" @click="closeModal" v-if="isOpen">
      <div class="content" @click.stop>
        <font-awesome-icon class="exit" icon="fa-xmark" @click="$emit('close')" />
        <h3>Select a Manager</h3>
        <p class="subtitle">Choose a manager to authorise this action</p>
        <div class="managers-list">
          <button v-for="manager in managers" :key="manager.id" @click="confirm(manager)" class="manager-button">
            <span class="avatar"><font-awesome-icon icon="fa-user" /></span>
            <span>{{ manager.value.firstName }} {{ manager.value.lastName }}</span>
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ManagerCheckModal",
  components: {},
  data() {
    return {};
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close", "confirm"],
  watch: {},
  computed: {
    ...mapGetters("training", {
      getStaff: "getStaff",
    }),

    managers() {
      return this.getStaff.filter((member) => member.value.manager && member.value.active !== false);
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    confirm(manager) {
      this.$emit("confirm", manager);
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  width: min(92vw, 28rem);
  padding: 1.5rem;
  border-radius: 1rem;
  background: var(--primary-colour);
  box-shadow: var(--box-shadow);

  .exit {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
    color: var(--text-colour);
    opacity: 0.5;
    &:hover { opacity: 1; }
  }

  h3 {
    margin: 0 0 0.25rem;
    color: var(--text-colour);
    font-size: 1.1rem;
  }

  .subtitle {
    margin: 0 0 1.25rem;
    font-size: 0.82rem;
    color: var(--text-colour);
    opacity: 0.55;
  }

  .managers-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .manager-button {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
      border: 1px solid var(--border-colour);
      background-color: var(--secondary-colour);
      color: var(--text-colour);
      cursor: pointer;
      font-size: 0.95rem;
      font-weight: 500;
      transition: border-color 0.15s ease, background-color 0.15s ease;
      text-align: left;

      &:hover {
        border-color: var(--action-colour);
        background-color: var(--opacity-background);
      }

      &:active {
        transform: scale(0.99);
      }

      .avatar {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background-color: var(--opacity-background);
        color: var(--action-colour);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }
    }
  }
}
</style>
